String.prototype.dj_fileName = function() {
    return this.substring(0, this.lastIndexOf("."));
}
String.prototype.dj_fileSuffix = function() {
    return this.substring(this.lastIndexOf('.')+1)
}
String.prototype.dj_fileTypeSuffix = function() {
    let mapper = this.dj_toArray('/');
    return mapper[mapper.length - 1];
}
String.prototype.dj_fileFullName = function() {
    return this.dj_fileName()+'.'+this.dj_fileSuffix;
}